export const crudFieldsData = {
    airline_arrival:[
    {
      id: 1,
      label: "Location",
      name: "location",
      value: "Amritsar",
      type: "text",
    },
    {
      id: 2,
      label: "Date",
      name: "date",
      type: "date",
      cName:'flex-auto'
    },
    {
      id: 3,
      label: "Time From",
      name: "time_from",
      type: "time",
      cName:'flex-auto'
    },
    {
      id: 4,
      label: "Time To",
      name: "time_to",
      type: "time",
      cName:'flex-auto'
    },
    {
      id: 5,
      label: "Flight 1",
      fields: [
        {
          id: 1,
          label: 'From',
          name: 'from_1',
          type: 'text',
        },
        {
          id: 2,
          label: 'Arriving at',
          name: 'time_1',
          type: 'time',
        }
      ]
    },
    {
      id: 6,
      label: "Flight 2",
      fields: [
        {
          id: 1,
          label: 'From',
          name: 'from_2',
          type: 'text',
        },
        {
          id: 2,
          label: 'Arriving at',
          name: 'time_2',
          type: 'time',
        }
      ]
    },
    {
      id: 7,
      label: "Flight 3",
      fields: [
        {
          id: 1,
          label: 'From',
          name: 'from_3',
          type: 'text',
        },
        {
          id: 2,
          label: 'Arriving at',
          name: 'time_3',
          type: 'time',
        }
      ]
    },
    {
      id: 8,
      label: "Flight 4",
      fields: [
        {
          id: 1,
          label: 'From',
          name: 'from_4',
          type: 'text',
        },
        {
          id: 2,
          label: 'Arriving at',
          name: 'time_4',
          type: 'time',
        }
      ]
    },
    {
      id: 9,
      label: "Flight 5",
      fields: [
        {
          id: 1,
          label: 'From',
          name: 'from_5',
          type: 'text',
        },
        {
          id: 2,
          label: 'Arriving at',
          name: 'time_5',
          type: 'time',
        }
      ]
    },
  ], 
  airline_departure:[
    {
      id: 1,
      label: "Location",
      name: "location",
      value: "Amritsar",
      type: "text",
    },
    {
      id: 2,
      label: "Date",
      name: "date",
      type: "date",
      cName:'flex-auto'
    },
    {
      id: 3,
      label: "Time From",
      name: "time_from",
      type: "time",
      cName:'flex-auto'
    },
    {
      id: 4,
      label: "Time To",
      name: "time_to",
      type: "time",
      cName:'flex-auto'
    },
    {
      id: 5,
      label: "Flight 1",
      fields: [
        {
          id: 1,
          label: 'To',
          name: 'to_1',
          type: 'text',
        },
        {
          id: 2,
          label: 'Departure',
          name: 'time_1',
          type: 'time',
        }
      ]
    },
    {
      id: 6,
      label: "Flight 2",
      fields: [
        {
          id: 1,
          label: 'To',
          name: 'to_2',
          type: 'text',
        },
        {
          id: 2,
          label: 'Departure',
          name: 'time_2',
          type: 'time',
        }
      ]
    },
    {
      id: 7,
      label: "Flight 3",
      fields: [
        {
          id: 1,
          label: 'To',
          name: 'to_3',
          type: 'text',
        },
        {
          id: 2,
          label: 'Departure',
          name: 'time_3',
          type: 'time',
        }
      ]
    },
    {
      id: 8,
      label: "Flight 4",
      fields: [
        {
          id: 1,
          label: 'To',
          name: 'to_4',
          type: 'text',
        },
        {
          id: 2,
          label: 'Departure',
          name: 'time_4',
          type: 'time',
        }
      ]
    },
    {
      id: 9,
      label: "Flight 5",
      fields: [
        {
          id: 1,
          label: 'To',
          name: 'to_5',
          type: 'text',
        },
        {
          id: 2,
          label: 'Departure',
          name: 'time_5',
          type: 'time',
        }
      ]
    },
  ], 
  train_departure:[
    {
      id: 1,
      label: "Location",
      name: "location",
      value: "Amritsar",
      type: "text",
    },
    {
      id: 2,
      label: "Date",
      name: "date",
      type: "date",
      cName:'flex-auto'
    },
    {
      id: 3,
      label: "Time From",
      name: "time_from",
      type: "time",
      cName:'flex-auto'
    },
    {
      id: 4,
      label: "Time To",
      name: "time_to",
      type: "time",
      cName:'flex-auto'
    },
    {
      id: 5,
      label: "Train 1",
      fields: [
        {
          id: 1,
          label: 'To',
          name: 'to_1',
          type: 'text',
        },
        {
          id: 2,
          label: 'Departure Time',
          name: 'time_1',
          type: 'time',
        },
        {
          id: 3,
          label: 'Departed at',
          name: 'departed_time_1',
          type: 'time',
        }
      ]
    },
    {
      id: 6,
      label: "Train 2",
      fields: [
        {
          id: 1,
          label: 'To',
          name: 'to_2',
          type: 'text',
        },
        {
          id: 2,
          label: 'Departure Time',
          name: 'time_2',
          type: 'time',
        },
        {
          id: 3,
          label: 'Departed at',
          name: 'departed_time_2',
          type: 'time',
        }
      ]
    },
    {
      id: 7,
      label: "Train 3",
      fields: [
        {
          id: 1,
          label: 'To',
          name: 'to_3',
          type: 'text',
        },
        {
          id: 2,
          label: 'Departure Time',
          name: 'time_3',
          type: 'time',
        },
        {
          id: 3,
          label: 'Departed at',
          name: 'departed_time_3',
          type: 'time',
        }
      ]
    },
    {
      id: 8,
      label: "Train 4",
      fields: [
        {
          id: 1,
          label: 'To',
          name: 'to_4',
          type: 'text',
        },
        {
          id: 2,
          label: 'Departure Time',
          name: 'time_4',
          type: 'time',
        },
        {
          id: 3,
          label: 'Departed at',
          name: 'departed_time_4',
          type: 'time',
        }
      ]
    },
    {
      id: 9,
      label: "Train 5",
      fields: [
        {
          id: 1,
          label: 'To',
          name: 'to_5',
          type: 'text',
        },
        {
          id: 2,
          label: 'Departure Time',
          name: 'time_5',
          type: 'time',
        },
        {
          id: 3,
          label: 'Departed at',
          name: 'departed_time_5',
          type: 'time',
        }
      ]
    },
  ], 
  train_arrival:[
    {
      id: 1,
      label: "Location",
      name: "location",
      value: "Amritsar",
      type: "text",
    },
    {
      id: 2,
      label: "Date",
      name: "date",
      type: "date",
      cName:'flex-auto'
    },
    {
      id: 3,
      label: "Time From",
      name: "time_from",
      type: "time",
      cName:'flex-auto'
    },
    {
      id: 4,
      label: "Time To",
      name: "time_to",
      type: "time",
      cName:'flex-auto'
    },
    {
      id: 5,
      label: "Train 1",
      fields: [
        {
          id: 1,
          label: 'From',
          name: 'from_1',
          type: 'text',
        },
        {
          id: 2,
          label: 'Arrival Time',
          name: 'time_1',
          type: 'time',
        },
        {
          id: 3,
          label: 'Arrived at',
          name: 'arrived_time_1',
          type: 'time',
        }
      ]
    },
    {
      id: 6,
      label: "Train 2",
      fields: [
        {
          id: 1,
          label: 'From',
          name: 'from_2',
          type: 'text',
        },
        {
          id: 2,
          label: 'Arrival Time',
          name: 'time_2',
          type: 'time',
        },
        {
          id: 3,
          label: 'Arrived at',
          name: 'arrived_time_2',
          type: 'time',
        }
      ]
    },
    {
      id: 7,
      label: "Train 3",
      fields: [
        {
          id: 1,
          label: 'From',
          name: 'from_3',
          type: 'text',
        },
        {
          id: 2,
          label: 'Arrival Time',
          name: 'time_3',
          type: 'time',
        },
        {
          id: 3,
          label: 'Arrived at',
          name: 'arrived_time_3',
          type: 'time',
        }
      ]
    },
    {
      id: 8,
      label: "Train 4",
      fields: [
        {
          id: 1,
          label: 'From',
          name: 'from_4',
          type: 'text',
        },
        {
          id: 2,
          label: 'Arrival Time',
          name: 'time_4',
          type: 'time',
        },
        {
          id: 3,
          label: 'Arrived at',
          name: 'arrived_time_4',
          type: 'time',
        }
      ]
    },
    {
      id: 9,
      label: "Train 5",
      fields: [
        {
          id: 1,
          label: 'From',
          name: 'from_5',
          type: 'text',
        },
        {
          id: 2,
          label: 'Arrival Time',
          name: 'time_5',
          type: 'time',
        },
        {
          id: 3,
          label: 'Arrived at',
          name: 'arrived_time_5',
          type: 'time',
        }
      ]
    },
  ], 
  bus_arrival:[
    {
      id: 1,
      label: "Location",
      name: "location",
      value: "Amritsar",
      type: "text",
    },
    {
      id: 2,
      label: "Date",
      name: "date",
      type: "date",
      cName:'flex-auto'
    },
    {
      id: 3,
      label: "Time From",
      name: "time_from",
      type: "time",
      cName:'flex-auto'
    },
    {
      id: 4,
      label: "Time To",
      name: "time_to",
      type: "time",
      cName:'flex-auto'
    },
    {
      id: 5,
      label: "Bus 1",
      fields: [
        {
          id: 1,
          label: 'From',
          name: 'from_1',
          type: 'text',
        },
        {
          id: 2,
          label: 'Arrival Time',
          name: 'time_1',
          type: 'time',
        },
        {
          id: 3,
          label: 'Arrived at',
          name: 'arrived_time_1',
          type: 'time',
        }
      ]
    },
    {
      id: 6,
      label: "Bus 2",
      fields: [
        {
          id: 1,
          label: 'From',
          name: 'from_2',
          type: 'text',
        },
        {
          id: 2,
          label: 'Arrival Time',
          name: 'time_2',
          type: 'time',
        },
        {
          id: 3,
          label: 'Arrived at',
          name: 'arrived_time_2',
          type: 'time',
        }
      ]
    },
    {
      id: 7,
      label: "Bus 3",
      fields: [
        {
          id: 1,
          label: 'From',
          name: 'from_3',
          type: 'text',
        },
        {
          id: 2,
          label: 'Arrival Time',
          name: 'time_3',
          type: 'time',
        },
        {
          id: 3,
          label: 'Arrived at',
          name: 'arrived_time_3',
          type: 'time',
        }
      ]
    },
    {
      id: 8,
      label: "Bus 4",
      fields: [
        {
          id: 1,
          label: 'From',
          name: 'from_4',
          type: 'text',
        },
        {
          id: 2,
          label: 'Arrival Time',
          name: 'time_4',
          type: 'time',
        },
        {
          id: 3,
          label: 'Arrived at',
          name: 'arrived_time_4',
          type: 'time',
        }
      ]
    },
    {
      id: 9,
      label: "Bus 5",
      fields: [
        {
          id: 1,
          label: 'From',
          name: 'from_5',
          type: 'text',
        },
        {
          id: 2,
          label: 'Arrival Time',
          name: 'time_5',
          type: 'time',
        },
        {
          id: 3,
          label: 'Arrived at',
          name: 'arrived_time_5',
          type: 'time',
        }
      ]
    },
  ], 
  bus_departure:[
    {
      id: 1,
      label: "Location",
      name: "location",
      value: "Amritsar",
      type: "text",
    },
    {
      id: 2,
      label: "Date",
      name: "date",
      type: "date",
      cName:'flex-auto'
    },
    {
      id: 3,
      label: "Time From",
      name: "time_from",
      type: "time",
      cName:'flex-auto'
    },
    {
      id: 4,
      label: "Time To",
      name: "time_to",
      type: "time",
      cName:'flex-auto'
    },
    {
      id: 5,
      label: "Bus 1",
      fields: [
        {
          id: 1,
          label: 'To',
          name: 'to_1',
          type: 'text',
        },
        {
          id: 2,
          label: 'Departure Time',
          name: 'time_1',
          type: 'time',
        },
        {
          id: 3,
          label: 'Departed at',
          name: 'departed_time_1',
          type: 'time',
        }
      ]
    },
    {
      id: 6,
      label: "Bus 2",
      fields: [
        {
          id: 1,
          label: 'To',
          name: 'to_2',
          type: 'text',
        },
        {
          id: 2,
          label: 'Departure Time',
          name: 'time_2',
          type: 'time',
        },
        {
          id: 3,
          label: 'Departed at',
          name: 'departed_time_2',
          type: 'time',
        }
      ]
    },
    {
      id: 7,
      label: "Bus 3",
      fields: [
        {
          id: 1,
          label: 'To',
          name: 'to_3',
          type: 'text',
        },
        {
          id: 2,
          label: 'Departure Time',
          name: 'time_3',
          type: 'time',
        },
        {
          id: 3,
          label: 'Departed at',
          name: 'departed_time_3',
          type: 'time',
        }
      ]
    },
    {
      id: 8,
      label: "Bus 4",
      fields: [
        {
          id: 1,
          label: 'To',
          name: 'to_4',
          type: 'text',
        },
        {
          id: 2,
          label: 'Departure Time',
          name: 'time_4',
          type: 'time',
        },
        {
          id: 3,
          label: 'Departed at',
          name: 'departed_time_4',
          type: 'time',
        }
      ]
    },
    {
      id: 9,
      label: "Bus 5",
      fields: [
        {
          id: 1,
          label: 'To',
          name: 'to_5',
          type: 'text',
        },
        {
          id: 2,
          label: 'Departure Time',
          name: 'time_5',
          type: 'time',
        },
        {
          id: 3,
          label: 'Departed at',
          name: 'departed_time_5',
          type: 'time',
        }
      ]
    },
  ], 
};